import React from 'react';

const ProgressBar = ({ value = 0, height = '10px', className = '' }) => {
  const safeValue = Math.min(Math.max(value, 0), 100); // Clamp between 0 and 100

  return (
    <div 
      className={`w-100 bg-light rounded ${className}`} 
      style={{ height, overflow: 'hidden' }}
    >
      <div 
        className="bg-primary" 
        style={{
          width: `${safeValue}%`,
          height: '100%',
          transition: 'width 0.5s ease'
        }}
      />
    </div>
  );
};

export default ProgressBar;
